(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["femarelle-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-fm-product]').forEach((section) => {
    const mainImage = section.querySelector('.fm-product__main-image');
    section.querySelectorAll('[data-fm-image]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!mainImage) return;
        mainImage.src = button.dataset.fmImage;
        mainImage.srcset = '';
        section.querySelectorAll('[data-fm-image]').forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
      });
    });
    const select = section.querySelector('[data-fm-variant]');
    const price = section.querySelector('[data-fm-price]');
    const compare = section.querySelector('[data-fm-compare]');
    const submit = section.querySelector('[data-fm-submit]');
    if (!select) return;
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      price.textContent = option.dataset.price;
      if (option.dataset.compare) {
        compare.textContent = option.dataset.compare;
        compare.hidden = false;
      } else {
        compare.hidden = true;
      }
      const available = option.dataset.available === 'true';
      submit.disabled = !available;
      submit.textContent = available ? 'In den Warenkorb' : 'Nicht verfügbar';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["femarelle-symptom-check"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-fm-quiz]').forEach((quiz) => {
    const form = quiz.querySelector('[data-quiz-form]');
    const steps = [...quiz.querySelectorAll('[data-quiz-step]')];
    const back = quiz.querySelector('[data-quiz-back]');
    const error = quiz.querySelector('[data-quiz-error]');
    const progressText = quiz.querySelector('[data-quiz-progress-text]');
    const progressBar = quiz.querySelector('[data-quiz-progress-bar]');
    const progress = quiz.querySelector('.fm-quiz__progress');
    const results = quiz.querySelector('[data-quiz-results]');
    const restart = quiz.querySelector('[data-quiz-restart]');
    let current = 0;

    const showStep = (index) => {
      current = index;
      steps.forEach((step, stepIndex) => { step.hidden = stepIndex !== index; });
      back.hidden = index === 0;
      progressText.textContent = `Schritt ${index + 1} von 3`;
      progressBar.style.width = `${((index + 1) / 3) * 100}%`;
      error.hidden = true;
    };

    const showResult = () => {
      const answers = steps.map((step) => step.querySelector('input:checked')?.value || 'none');
      const scores = { rejuvenate: 0, recharge: 0, unstoppable: 0 };
      answers.forEach((answer) => {
        if (scores[answer] !== undefined) scores[answer] += 1;
      });
      const preference = answers[2];
      const highest = Math.max(...Object.values(scores));
      const leaders = Object.keys(scores).filter((key) => scores[key] === highest);
      const winner = leaders.includes(preference) ? preference : leaders[0];
      form.hidden = true;
      progress.hidden = true;
      results.hidden = false;
      quiz.querySelectorAll('[data-quiz-result]').forEach((result) => {
        result.hidden = result.dataset.quizResult !== winner;
      });
      results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    back.addEventListener('click', () => showStep(Math.max(0, current - 1)));
    form.addEventListener('change', (event) => {
      if (!event.target.matches('input[type="radio"]')) return;
      error.hidden = true;
      window.setTimeout(() => {
        if (current < steps.length - 1) showStep(current + 1);
        else showResult();
      }, 180);
    });
    restart.addEventListener('click', () => {
      form.reset();
      form.hidden = false;
      progress.hidden = false;
      results.hidden = true;
      showStep(0);
      quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    showStep(0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
